import { inject, Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  JwtAuthenticationStore,
  LogoutService,
  SOFTLINE_CONFIG_AUTHENTICATION_ROUTE,
  SOFTLINE_FEATURE_JWT_AUTHENTICATION,
} from '@softline/auth';
import { Store } from '@softline/core';
import { MessageBarStore, SOFTLINE_FEATURE_MESSAGE_BAR } from '@softline/ui-core';
import { GuardService } from './guard.service';

@Injectable({
  providedIn: 'root',
})
export class SoftAppsLogoutService extends LogoutService {
  public static GUARD_TYPE = 'SHELL/LOGOUT' as const;

  private guardService = inject(GuardService);

  constructor(
    private store: Store,
    private router: Router,
    @Inject(SOFTLINE_CONFIG_AUTHENTICATION_ROUTE) private loginRoute: string
  ) {
    super();
  }

  async logout(): Promise<void> {
    const guards = this.guardService.guards(SoftAppsLogoutService.GUARD_TYPE);

    const results: boolean[] = [];

    for (const guardFn of guards) {
      results.push(await guardFn());
    }

    if (results.length > 0 && results.includes(false)) {
      return;
    }

    // Leave the page BEFORE dropping the token: a route's canDeactivate guard
    // may still need the session — an open sales document finalizes from it,
    // and that request 401s once the token is gone. A cancelled navigation
    // (dialog dismissed, finalize failed) therefore keeps the user logged in.
    if (!this.router.url.startsWith('/terminal')) {
      if (!(await this.router.navigate([this.loginRoute]))) return;
    }

    await this.store.dispatch(
      SOFTLINE_FEATURE_JWT_AUTHENTICATION,
      JwtAuthenticationStore.actions.logout
    );

    await this.store.dispatch(
      SOFTLINE_FEATURE_MESSAGE_BAR,
      MessageBarStore.actions.success,
      '#LOGIN.MESSAGES.LOGOUT'
    );
  }
}
